<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
               <v-card flat>
                  <v-card-title class="headline">
                     Idee Ansicht
                  </v-card-title>
               </v-card>
               <v-card>
                  <v-system-bar style="height: auto;" class="px-4" color="#f5f5f5">
                     {{ idea.creator_last_name }}, {{ idea.creator_first_name }}<span class="mx-1"
                                                                                      v-if="idea.creator_orga_unit">({{
                        idea.creator_orga_unit
                     }})</span>
                     am {{ idea.created_at }}
                     <v-spacer/>
                     <v-btn outlined rounded color="primary" small v-if="$can('update idea ideaState')"
                            @click="stateForm = true;">Status ändern
                     </v-btn>
                     <v-tooltip bottom v-if="canEdit">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              :to="{name: 'IdeasWorkbenchIdeasEdit', params: {id: idea.id}}"
                           >
                              <v-icon color="primary" class="ma-0">mdi-circle-edit-outline</v-icon>
                           </v-btn>
                        </template>
                        <span>Bearbeiten</span>
                     </v-tooltip>
                     <v-tooltip bottom v-if="!idea.is_subscribed">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="subscribeFeed(idea.id, 'idea')"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell-outline</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen erhalten</span>
                     </v-tooltip>
                     <v-tooltip bottom v-if="idea.is_subscribed">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="unsubscribeFeed(idea.feed_id)"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen abstellen</span>
                     </v-tooltip>
                  </v-system-bar>
                  <v-card-title class="subtitle-1">
                     {{ idea.title }}
                  </v-card-title>
                  <v-card-subtitle>
                     <div class="d-flex justify-space-between">
                        <div>
                           <v-chip small label :outlined="idea.current_state.name === 'open'"
                                   :color="getStateColor(idea.current_state.name)">
                              <v-avatar left>
                                 <v-icon small>{{ getStateIcon(idea.current_state.name) }}</v-icon>
                              </v-avatar>
                              {{ idea.current_state.name_de }}
                           </v-chip>
                           <span v-if="idea.current_state.name !== 'open'"> am {{
                                 idea.current_state.created_at
                              }}</span>
                        </div>
                     </div>
                     <div v-if="idea.current_state.comment">
                        {{ idea.current_state.comment }}
                     </div>
                  </v-card-subtitle>
                  <v-card-text class="black--text" v-html="idea.description"/>
                  <v-card-text v-if="idea.is_voting">
                     <v-btn outlined class="mr-1" style="pointer-events: none;">{{ idea.votes }}</v-btn>
                     <v-btn :color="color(idea.was_voted, true)" outlined class="mr-1"
                            @click.prevent="vote(1, idea.id)">Up
                        <v-icon>mdi-chevron-up</v-icon>
                     </v-btn>
                     <v-btn :color="color(idea.was_voted)" outlined class="mr-1" @click.prevent="vote(-1, idea.id)">Down
                        <v-icon>mdi-chevron-down</v-icon>
                     </v-btn>
                  </v-card-text>
               </v-card>
               <v-card flat class="mt-4 mb-n2">
                  <v-card-title>
                     Kommentare ({{ idea.comments_count }})
                  </v-card-title>
               </v-card>
               <v-card v-for="(item, index) in idea.comments" :key="index" class="mt-6">
                  <v-system-bar style="height: auto;" class="px-4" color="transparent">
                     {{ item.creator_last_name }}, {{ item.creator_first_name }}<span class="mx-1"
                                                                                      v-if="item.creator_orga_unit">({{
                        item.creator_orga_unit
                     }})</span>
                     am {{ item.created_at }}
                     <v-chip class="ml-1" v-if="item.is_new" color="primary" small>Neu</v-chip>
                     <v-spacer/>
                     <v-tooltip bottom v-if="!item.feed_id">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              :disabled="disabledSubscribeIdea"
                              @click="subscribeFeed(item.id, 'comment')"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell-outline</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen erhalten</span>
                     </v-tooltip>
                     <v-tooltip bottom v-if="item.feed_id">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="unsubscribeFeed(item.feed_id)"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen abstellen</span>
                     </v-tooltip>
                  </v-system-bar>
                  <v-card-text class="black--text py-2">
                     {{ item.body }}
                  </v-card-text>
                  <v-expansion-panels flat hover>
                     <v-expansion-panel v-if="item.children_count > 0">
                        <v-expansion-panel-header class="px-4">
                           <span class="primary--text">Antworten ({{ item.children_count }}) ansehen <v-chip
                              v-if="item.new_children_count > 0" class="ml-1" color="primary"
                              small>{{ item.new_children_count }} Neu</v-chip></span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="mx-n2">
                           <v-card flat class="mt-3" v-for="(item, index) in item.children" :key="index">
                              <v-system-bar style="height: auto;" class="px-4" color="transparent">
                                 {{ item.creator_last_name }}, {{ item.creator_first_name }}<span class="mx-1"
                                                                                                  v-if="item.creator_orga_unit">({{
                                    item.creator_orga_unit
                                 }})</span>
                                 am {{ item.created_at }}
                                 <v-chip class="ml-1" v-if="item.is_new" color="primary" small>Neu</v-chip>
                                 <v-spacer/>
                              </v-system-bar>
                              <v-card-text class="black--text py-2">{{ item.body }}</v-card-text>
                           </v-card>
                        </v-expansion-panel-content>
                     </v-expansion-panel>
                  </v-expansion-panels>
                  <v-card-text class="black--text py-2 px-1">
                     <v-btn text small @click="item.is_answering = !item.is_answering">
                        Antworten
                     </v-btn>
                  </v-card-text>
                  <v-card-text class="py-2" v-if="item.is_answering">
                     <v-form ref="newComment" v-model="validNewComment">
                        <v-textarea outlined :counter="1500" :rules="commentRules" v-model="item.answer_body"
                                    label="Neuer Kommentar"/>
                        <div class="d-flex justify-end">
                           <v-btn class="mr-4" outlined small :disabled="!validNewComment || !item.answer_body"
                                  color="primary" @click="resetCommentForm">Abbrechen
                           </v-btn>
                           <v-btn small depressed :disabled="!validNewComment || !item.answer_body" color="primary"
                                  @click="postComment(idea.id, item.id,item.answer_body); item.is_answering = false;">
                              Absenden
                           </v-btn>
                        </div>
                     </v-form>
                  </v-card-text>
               </v-card>
               <v-card flat class="mt-4">
                  <v-card-text>
                     <v-form ref="comment" v-model="validNewComment">
                        <v-textarea outlined :counter="1500" :rules="commentRules" v-model="comment.body"
                                    label="Neuer Kommentar"/>
                        <div class="d-flex justify-end">
                           <v-btn class="mr-4" outlined small :disabled="!validNewComment || !comment.body"
                                  color="primary" @click="resetCommentForm">Abbrechen
                           </v-btn>
                           <v-btn small depressed :disabled="!validNewComment || !comment.body" color="primary"
                                  @click="postComment(idea.id, null,comment.body)">Absenden
                           </v-btn>
                        </div>
                     </v-form>
                  </v-card-text>
               </v-card>
               <v-card flat class="mt-4 mb-n2">
                  <v-card-title>
                     Historie
                  </v-card-title>
                  <v-card-text v-for="state in idea.states" :key="state.id">
                     <div>
                        <v-chip small label :color="getStateColor(state.name)">{{ state.name_de }}</v-chip>
                        <span> am {{ state.created_at }}</span>
                     </div>
                     <div v-if="state.comment">
                        {{ state.comment }}
                     </div>
                  </v-card-text>
               </v-card>
            </v-col>
         </v-row>
      </div>
      <v-dialog
         v-model="stateForm"
         max-width="500"
      >
         <v-card>
            <v-card-title class="headline">
               Status ändern
            </v-card-title>
            <v-card-text>
               <v-form ref="stateForm">
                  <v-autocomplete
                     outlined
                     label="Status"
                     v-model="idea_state_id"
                     :items="ideaStates"
                     item-value="id"
                     item-text="name_de"
                  >
                     <template v-slot:selection="data">
                        <v-avatar size="24" class="mr-2" :color="getStateColor(data.item.name)"/>
                        {{ data.item.name_de }}
                     </template>
                     <template v-slot:item="data">
                        <v-list-item-icon>
                           <v-icon :color="getStateColor(data.item.name)">{{ getStateIcon(data.item.name) }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                           <v-list-item-title>{{ data.item.name_de }}</v-list-item-title>
                           <v-list-item-subtitle v-if="data.item.comment">{{ data.item.comment }}</v-list-item-subtitle>
                        </v-list-item-content>
                     </template>
                  </v-autocomplete>
                  <v-textarea label="Kommentar" outlined v-model="state_comment"/>
               </v-form>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn
                  color="primary"
                  outlined
                  @click="stateForm = false"
               >
                  Abbrechen
               </v-btn>
               <v-btn
                  class="ml-2"
                  color="primary"
                  depressed
                  @click="stateForm = false; addState();"
               >
                  Absenden
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   props: [],
   name: "",
   data: () => ({
      ideaStates: [],
      idea_state_id: null,
      state_comment: '',
      stateForm: false,
      idea: {},
      comment: {
         body: '',
         answer_body: '',
      },
      validNewComment: true,
      commentRules: [
         v => !!v || '',
         v => (v && v.length <= 1500) || 'Der Kommentar muss weniger als 1500 Zeichen haben.',
      ],
      disabledSubscribeIdea: false,
   }),
   created() {
      if (this.$route.params.id) {
         this.getIdea();
         this.getStates();
      }
      console.log(this.isVoting)

   },
   computed: {
      canEdit: function () {
         let userId = this.$store.getters["user/userDetails"].id;
         return this.$can('store ideasCategory') || (userId === this.idea.user_id);
      },
      userDetails: function (){
         return this.$store.getters['user/userDetails'];
      }
   },
   methods: {
      ...mapActions({}),
      getIdea() {
         this.disabledSubscribeIdea = true;
         this.axios.get('/ideas/' + this.$route.params.id).then((r) => {
            this.idea = r.data.data;
            this.disabledSubscribeIdea = false;
         })
      },

      /**
       * Feed
       */
      subscribeFeed(id, type) {
         var data = {};
         data.feedable_type = type;
         data.feedable_id = id;

         this.axios.post('/feeds', {
            'feed': data
         }).then(() => {
            this.$toast.success('Sie erhalten nun Benachrichtigungen der Idee.');
            this.getIdea();
         })
      },
      unsubscribeFeed(id) {
         this.axios.delete('/feeds/' + id).then(() => {
            this.$toast.success('Sie erhalten nun keine Benachrichtigungen der mehr.');
            this.getIdea();
         })
      },

      /**
       * Comments
       */
      postComment(id, parent_id, body) {
         var data = {};
         data.commentable_type = 'idea';
         data.commentable_id = id;
         data.body = body;
         data.parent_id = parent_id;

         this.axios.post('/comments', {
            'comment': data
         }).then(() => {
            this.getIdea();
            this.resetCommentForm();
            this.$toast.success('Der Kommentar wurde erfolgreich gepostet.');
         })
      },
      deleteComment(id) {
         this.axios.delete('/comments/' + id).then(() => {
            this.$toast.success('Der Kommentar wurde erfolgreich gelöscht.');
            this.getIdea();
         })
      },
      resetCommentForm() {
         this.$refs.comment.reset()
      },
      vote(value, id) {
         this.axios.post('/ideas/' + id + '/vote', {
            'value': value
         }).then(() => {
            this.$toast.success('Der Vote wurde erfolgreich platziert.');
            this.getIdea();
         }).catch((e) => {
            console.log(e);
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      color(vote, positive) {
         if (vote === 1 && positive) {
            return 'green darken-2';
         } else if (vote === -1 && !positive) {
            return 'red';
         } else {
            return 'grey lighten-1';
         }
      },
      getStateColor(state) {
         switch (state) {
            case 'open':
               return 'success';
            case 'review':
               return 'info';
            case 'declined':
               return 'warning';
            case 'accepted':
               return 'success';
            case 'realized':
               return 'success darken-1';
            case 'closed':
               return 'error';
         }
      },
      addState() {
         let data = {};
         data.idea_state_id = this.idea_state_id;
         data.comment = this.state_comment;
         this.axios.post('/ideas/' + this.idea.id + '/add-state', {
            'item': data,
         }).then(() => {
            this.$toast.success('Der Status wurde erfolgreich geändert.');
            this.getIdea();
         }).catch((e) => {
            console.log(e);
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      getStates() {
         this.axios.get('/idea-states').then((r) => {
            this.ideaStates = r.data.items;
         })
      },
      getStateIcon(state) {
         switch (state) {
            case 'open':
               return 'mdi-checkbox-blank-circle-outline';
            case 'review':
               return 'mdi-clock-outline';
            case 'declined':
               return 'mdi-close-circle-outline';
            case 'accepted':
               return 'mdi-arrow-top-right-thin-circle-outline';
            case 'realized':
               return 'mdi-check-circle-outline';
            case 'closed':
               return 'mdi-checkbox-blank-circle';
         }
      },
   },
}
</script>

<style scoped>

</style>
